import {
    BULK_TAGS_REQUEST,
    BULK_TAGS_RESULT,
    BULK_TAGS_OPEN_MODAL,
    BULK_TAGS_CLOSE_MODAL,
    BULK_TAGS_GET_DEVICE_REQUEST,
    BULK_TAGS_GET_DEVICE_RESULT,
    BULK_TAGS_SET_DEVICE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    devices: [],
    selectedDevices: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case BULK_TAGS_REQUEST:
            return { ...state, loading: true }

        case BULK_TAGS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case BULK_TAGS_OPEN_MODAL:
            return { ...state, openModal: true, selectedDevices: action.payload }

        case BULK_TAGS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case BULK_TAGS_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case BULK_TAGS_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case BULK_TAGS_SET_DEVICE:
            return { ...state, devices: action.payload }


        case CLEAR_REDUX:
            return ["", "BULK_TAGS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};